import { render, staticRenderFns } from "./ReservationConfirmation.vue?vue&type=template&id=e265e28c&scoped=true&"
import script from "./ReservationConfirmation.vue?vue&type=script&lang=js&"
export * from "./ReservationConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ReservationConfirmation.vue?vue&type=style&index=0&id=e265e28c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e265e28c",
  null
  
)

export default component.exports